import ArticleListing from '4-sections/FilteredListings/ArticleListing/ArticleListing';
import React from 'react';
import ReactDOM from 'react-dom';

global.React = React;
global.ReactDOM = ReactDOM;

global.Components = { ArticleListing };
